import { BaseApiService } from '@/_services/baseApi.service'

export class FirebaseService extends BaseApiService {
  constructor () {
    super()
  }

  setToken (data) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/push-notification/add/token`
    return this.sendPostRequest(url, data)
  }
}
export default new FirebaseService()
